export default {
    "type": "object",
    "required": [ 'ordesc', 'orprice' ],
    "properties": {
        "ordesc": {
            "type": "string",
            "default": "",
            "title": "Extra Charge Description",
            "x-cols": "8",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 255
            }
        },
        "orprice": {
            "type": "string",
            "default": "",
            "title": "Cost",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "prefix": "RM",
                "maxlength": 10
            }
        },
    }
}
